import React from "react";
import { Row, Col, Tooltip, Divider, Form, Button } from "antd";
import { PlusCircleFilled, MinusCircleOutlined } from "@ant-design/icons";
import type { FormInstance } from "antd/es/form/Form";
import { AccountCreateActiveModal } from "../types/AccountCreateActiveModal";
import { CreateAccountData } from "../types/CreateAccountData";
import { ContactIndividualModal } from "./ContactIndividualModal";
import { SetActiveModal } from "../../../lib/utils/useActiveModal";
import { AnyObject } from "../../../lib/interfaces";
import { ReactComponent as EditIcon } from "../../../img/versions_icons/editVersion_icon.svg";
// import { ContactIndividualCreate } from "../types/ContactIndividualCreate";

interface ContactIndividualFormItemProps {
  activeModal: AccountCreateActiveModal;
  setActiveModal: SetActiveModal<AccountCreateActiveModal>;
  formInstance: FormInstance<CreateAccountData>;
  activeModalOptions?: AnyObject;
}

// interface TableRecord extends ContactIndividualCreate {
//   key: string;
// }

export const ContactIndividualFormItem = (props: ContactIndividualFormItemProps) => {
  const { activeModal, setActiveModal, formInstance, activeModalOptions } = props;

  const contactIndividualFormData: CreateAccountData["contactIndividual"] = formInstance.getFieldValue(
    "contactIndividual"
  );

  console.log(contactIndividualFormData);

  // const [tableData, setTableData] = useState<TableRecord[]>();

  // useEffect(() => {
  //   // const properties = account.organization.contactIndividual.map((item) => item.properties).flat();
  //   // const position = properties.find(({ typeId }) => typeId === "position");
  //   // const positionName = position?.stringValue
  //   //   ?.split("")
  //   //   .map((item, i) => (i > 0 ? item : item.toUpperCase()));
  //   if (contactIndividualFormData) {
  //     setTableData(
  //       contactIndividualFormData.map((user, idx) => ({
  //         key: `${idx}`,
  //         ...user,
  //       }))
  //     );
  //   }
  // }, [contactIndividualFormData]);

  // const columnsWidths = {
  //   lastName: "15%",
  //   firstName: "17%",
  //   middleName: "17%",
  //   email: "",
  //   actions: "90px",
  // };

  // const [columns, setColumns] = useState([
  //   {
  //     title: "Фамилия",
  //     dataIndex: "lastName",
  //     key: "lastName",
  //     width: columnsWidths.lastName,
  //   },
  //   {
  //     title: "Имя",
  //     dataIndex: "firstName",
  //     key: "firstName",
  //     width: columnsWidths.firstName,
  //   },
  //   {
  //     title: "Отчество",
  //     dataIndex: "middleName",
  //     key: "middleName",
  //     width: columnsWidths.middleName,
  //   },
  //   {
  //     title: "Email",
  //     dataIndex: "email",
  //     key: "email",
  //     width: columnsWidths.email,
  //   },
  //   {
  //     dataIndex: "actions",
  //     key: "actions",
  //     width: columnsWidths.actions,
  //     render: () => {
  //       const onClick = () => {};
  //       return <MinusCircleOutlined className="minus-icon" onClick={onClick} />;
  //     },
  //   },
  // ]);

  const renderTitle = (title, index) =>
    index === 0 ? (
      <div
        style={{
          fontSize: "13px",
          margin: "3px 0 5px 0",
          color: "rgba(0, 0, 0, 0.85)",
        }}
      >
        {title}
      </div>
    ) : null;

  const renderFormItem = (props) => {
    const { fieldName, formRecord, contactIndividualFormData, titleName, index } = props;
    const value = contactIndividualFormData?.[index]?.[fieldName];
    return (
      <>
        {renderTitle(titleName, index)}
        <Form.Item
          {...formRecord}
          name={[formRecord.name, fieldName]}
          className="form-item-required__hidden-error__mb0"
        >
          <span>{value}</span>
        </Form.Item>
      </>
    );
  };

  const renderFields = (fields, contactIndividualFormData, remove) => {
    return fields.map((formRecord, index) => {
      return (
        <React.Fragment key={formRecord.key}>
          <Row gutter={20} wrap={false}>
            <Col span={5}>
              {renderFormItem({
                formRecord,
                index,
                contactIndividualFormData,
                fieldName: "lastName",
                titleName: "Фамилия",
              })}
            </Col>
            <Col span={5}>
              {renderFormItem({
                formRecord,
                index,
                contactIndividualFormData,
                fieldName: "firstName",
                titleName: "Имя",
              })}
            </Col>
            <Col span={5}>
              {renderFormItem({
                formRecord,
                index,
                contactIndividualFormData,
                fieldName: "middleName",
                titleName: "Отчество",
              })}
            </Col>
            <Col span={1} offset={3}>
              <Button
                className="button-icon"
                style={{
                  marginTop: index === 0 ? "28px" : 0,
                  marginLeft: "5px",
                }}
                icon={<EditIcon />}
                type="text"
                htmlType="button"
                onClick={() => {
                  setActiveModal("contactIndividual", { ...contactIndividualFormData[index] });
                }}
              />
            </Col>
            <Col span={1}>
              <MinusCircleOutlined
                className="minus-icon"
                style={{
                  marginTop: index === 0 ? "38px" : "10px",
                  marginLeft: "5px",
                }}
                onClick={() => {
                  remove(formRecord.name);
                }}
              />
            </Col>
          </Row>
        </React.Fragment>
      );
    });
  };

  return (
    <>
      <Row style={{ display: "flex", alignItems: "top", marginBottom: 0 }}>
        <Col span={4} style={{ display: "flex" }}>
          <h3>Контактные лица</h3>
          <Tooltip title="Добавить контактное лицо">
            <PlusCircleFilled
              className="plus-icon"
              style={{ margin: "6px 0 0 8px" }}
              onClick={() => setActiveModal("contactIndividual")}
            />
          </Tooltip>
        </Col>
      </Row>
      <Form.List name="contactIndividual">
        {(fields, { add, remove }) => {
          const addContactIndividual = (contactIndividual) => {
            add({ ...contactIndividual });
          };

          return (
            <>
              {renderFields(fields, contactIndividualFormData, remove)}
              <ContactIndividualModal
                visible={activeModal === "contactIndividual"}
                setActiveModal={setActiveModal}
                onSubmit={addContactIndividual}
                contactIndividualFormData={contactIndividualFormData}
                activeModalOptions={activeModalOptions}
              />
            </>
          );
        }}
      </Form.List>
      <Divider style={{ marginTop: 0 }} />
    </>
  );
};
